<!-------------searching--------------
<div class="input-group">
    <input type="search" class="form-control form-control-lg" placeholder="Type your keywords here">
    <div class="input-group-append">
    <button type="submit" class="btn btn-lg btn-default">
    <i class="fa fa-search"></i>
    </button>
    </div>
    </div>
    -->
<!-----------------fillering------------------->
<div class="card-body">
    <div class="row">
    <div class="col-md-6">
    <div class="form-group">
        <label>From Date</label>
        <input type="date" class="form-control" [(ngModel)]="data8.from_date">
    </div>
    <div class="form-group">
     <label>Select Employee</label>

     <div class="input-group">
        <input type="search" class="form-control form-control-lg" placeholder="Search employee" [(ngModel)]="data8.emp_name" (ngModelChange)="SearchEmployee();">
        <button type="submit" class="btn btn-lg btn-default" (click)="SearchEmployee();">
        <i class="fa fa-search"></i>
        </button>
        </div>
       
            <div class="card card-default"  *ngIf="isShownEmployee">
            <div *ngFor="let c of employee" >
            <h4 class="font" (click)="getEmployeeId(c.employee_id,c.employee_name)"><b>{{c.employee_name}}</b></h4>
            </div>
            </div>
     <!--
       <select #teams (change)="onSelected(teams.value)" class="form-control select2 select2-hidden-accessible" style="width: 100%;" data-select2-id="1" tabindex="-1" aria-hidden="true" [(ngModel)]="data.responsible_employee_id">
        <option selected="selected" data-select2-id="1"> </option>   
        <option *ngFor="let d of employee" data-select2-id="2"  [value]="d.employee_id">{{d.employee_name}}</option>
        </select> 
    -->
    </div>

    </div>
    
    <div class="col-md-6">
    <div class="form-group">
   

        <div class="form-group">
            <label>To Date</label>
            <input type="date" class="form-control"  name="Todate" [(ngModel)]="data8.to_date">
        </div>
        <div class="form-group">
            <label>Select Customer</label>

            <div class="input-group">
                <input type="search" class="form-control form-control-lg" placeholder="Search customer" [(ngModel)]="data8.c_name" (ngModelChange)="SearchCustomer();">
                <button type="submit" class="btn btn-lg btn-default" (click)="SearchCustomer();">
                <i class="fa fa-search"></i>
                </button>
                </div>
               
                <div class="card card-default"  *ngIf="isShownCustomer">
                <div *ngFor="let c of customers" >
                <h4 class="font" (click)="getCustomerId(c.customer_id,c.customer_name)"><b>{{c.customer_name}}</b></h4>
                </div>
                </div>

           </div>
    </div>
</div>
  
    <button type="submit" class="btn btn-primary btn_allign style" (click)="btnClick()">Apply</button>
    
<!---------------------------------------->
<div class="form-group">
    <div class="form-group">
        <label>Total Sales Value</label>
        <input type="text" class="form-control width" [readonly]="true" value='{{salesValue}}'>
    </div>

<!---------------------------------------->
<div *ngIf=loaderShown class="loader"></div>

<!---------------------------------new ui---------------------------------------------------->

    <section class="content-header" *ngIf=tableShown>
        
        <div class="row mb-2 ">
        <div class="col-sm-6">
        <h1>Sales</h1>
        </div>
        </div>
       
        </section>
    <section class="content" *ngIf=tableShown>
    
    <div class="card">
    <div class="card-header">
    
    <div class="card-tools">
    <button type="button" class="btn btn-tool" data-card-widget="collapse" title="Collapse">
    <i class="fas fa-minus"></i>
    </button>
    <button type="button" class="btn btn-tool" data-card-widget="remove" title="Remove">
    <i class="fas fa-times"></i>
    </button>
    </div>
    </div>
    <div class="card-body p-0">
    <table class="table table-striped projects">
    <thead>
    <tr>
   

    <th style="width: 20%">
    Sales Number
    </th>

    <th style="width: 25%">
    Date
    </th>

    <th style="width:30%">
    Company Name
    </th>
    
    <th style="width:10%">
    Total Amount
    </th>

    <th>
    </th>
   
    </tr>
    </thead>
    <tbody>

    <tr *ngFor="let c of output">
    <td>
    <a>
    {{c.invoice_number}}
    </a>
    </td>
    
    <td>
    {{DateFormat(c.date_time)}}
    </td>

    
    <td>
    {{c.company_name}}
    </td>

    <td>
    {{c.total_amount}}
    </td>
    
    
    <td class="project-actions text-right">
    <a class="btn btn-primary btn-sm" (click)='InvoiceDetails();getValue(c.invoice_id)'>
    <i class="fas fa-folder">
    </i>
    View
    </a>
    </td>
    </tr>
    

    </tbody>
    </table>
    </div>
    
    </div>
    
    </section>
<!------------------paging---------------------->
<div class="col-sm-12 col-md-7" *ngIf=tableShown>
    <div class="dataTables_paginate paging_simple_numbers" id="example2_paginate">
        <ul class="pagination">
            <li class="paginate_button page-item previous" id="example2_previous">
            <a  (click)="clicks_previous()" aria-controls="example2" data-dt-idx="0" tabindex="0" class="page-link">Previous</a></li>

            <li class="paginate_button page-item "><a aria-controls="example2" data-dt-idx="1" tabindex="0" class="page-link">{{count+1}}</a></li>
           
            <li class="paginate_button page-item next" id="example2_next">
            <a (click)="clicks_next()" aria-controls="example2" data-dt-idx="7" tabindex="0" class="page-link">Next</a></li>
        </ul>
    </div></div>
    